import NephroTransplant from './nephro-transplant';
import templateOnly from '@ember/component/template-only';
import ObservanceAndPersistencePage from './content/observance-and-persistence-page';
import { get } from '@ember/object';
import { ComponentLike } from '@glint/template';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const DefaultPage = setComponentTemplate(precompileTemplate("\n  <ObservanceAndPersistencePage @patient={{@patient}} />\n", {
  strictMode: true,
  scope: () => ({
    ObservanceAndPersistencePage
  })
}), templateOnly(undefined, "score-result-page:DefaultPage"));
const Pages = {
  'mental-bipolar': DefaultPage,
  'onco-breast-cancer': DefaultPage,
  'onco-breast-cancer-tnm0': DefaultPage,
  'nephro-transplant': NephroTransplant
};
const ScoreResultPage = setComponentTemplate(precompileTemplate("\n  {{#let (get Pages @patient.followUpReason) as |FurComponent|}}\n    {{#if FurComponent}}<FurComponent @patient={{@patient}} />{{/if}}\n  {{/let}}\n", {
  strictMode: true,
  scope: () => ({
    get,
    Pages
  })
}), templateOnly(undefined, "score-result-page:ScoreResultPage"));
export default ScoreResultPage;